/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_CreatingInputs */

const he_common_creating = /** @type {(inputs: Common_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יוצר...`)
};

const en_common_creating = /** @type {(inputs: Common_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating...`)
};

/**
* | output |
* | --- |
* | "Creating..." |
*
* @param {Common_CreatingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const common_creating = /** @type {((inputs?: Common_CreatingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_CreatingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_creating(inputs)
	return en_common_creating(inputs)
});